// extracted by mini-css-extract-plugin
export default {"success":"DisplayCoordinates_success__iBKpW","error":"DisplayCoordinates_error__D2-4R"};